export function objectEntries<T extends object, K extends Extract<keyof T, string>>(obj: T) {
  return Object.entries(obj) as [K, T[K]][];
}

export function objectKeys<T extends object, K extends Extract<keyof T, string>>(obj: T) {
  return Object.keys(obj) as K[];
}

export function objectValues<T extends object, K extends Extract<keyof T, string>>(obj: T) {
  return Object.values(obj) as T[K][];
}

export function objectFromEntries<T extends string, K>(arr: [T, K][]) {
  return Object.fromEntries(arr) as Record<T, K>;
}
